import { acceptHMRUpdate, defineStore } from 'pinia'
import donatedService from '@/services/donated.service'

export const useDonatedStore = defineStore({
  id: 'donatedStore',
  state: () => ({
    donatedAwards: [],
    convertedAwards: []
  }),
  setup () {},
  actions: {
    getDonatedList () {
      return donatedService.getDonatedList().then(
        response => {
          const convertedAwards = response.data.convertedAwards || response.data.myDonations || []
          this.convertedAwards = convertedAwards
          this.donatedAwards = convertedAwards
          return response
        }
      )
    },
    getConvertedAwardCode (awardUserId) {
      return donatedService.getConvertedAwardCode(awardUserId).then(response => response.data)
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDonatedStore, import.meta.hot))
}
